import { NotFound404 } from 'routes/home/404';

export const NotFound = () => (
  <>
    <NotFound404></NotFound404>
  </>
);
